import { RequestDueDate } from '@/components/DueDate';
import Stack from '@/design_system/Stack';
import IconCalendar from '@/icons/Calendar.svg';
import { getEstimatedDueAtDate, RequestWithRelationsFromRequestsList } from '@/models/request';

export const RequestDueAtCell = ({
  request,
  variant,
}: {
  request: RequestWithRelationsFromRequestsList;
  variant: 'card' | 'row';
}) => {
  if (!request.dueAt) {
    return (
      <Stack
        row
        gap={variant === 'card' ? '0.25rem' : '0.5rem'}
        alignItems="center"
        flexWrap="nowrap"
      >
        <IconCalendar style={{ fontSize: '1rem' }} />-
      </Stack>
    );
  }

  return (
    <RequestDueDate
      date={new Date(request.dueAt)}
      estimatedDate={getEstimatedDueAtDate(request)}
      variant={variant}
      displayDayMonthOnly={variant === 'card'}
    />
  );
};
